(() => {
  window.swinger.observer.initialize('.swinger-verification', (elem) => {
    const data = window.swinger.storage.get('swinger.verification');
    if (!data) return;

    window.swinger.i18n().then((i18n) => {
      const text = i18n(atob('dWkudmVyaWZpY2F0aW9uLnRleHQud2l0aC1lbWFpbA=='), { [atob('ZW1haWw=')]: atob(data) });
      const formattedText = text.split(/\r?\n\r?\n/).map((paragraph) => `<p>${window.swinger.md(paragraph)}</p>`).join('\n\n');
      elem.querySelector('.swinger-richtext').innerHTML = formattedText;
    });
  }, false);
})();
